import { Component, OnInit } from "@angular/core";
import { CalculatorMessagesService } from "../service/calculator-messages.service";

@Component({
  selector: "app-calculator-messages-page",
  templateUrl: "./calculator-messages-page.component.html",
  styleUrls: ["./calculator-messages-page.component.scss"]
})
export class CalculatorMessagesPageComponent implements OnInit {



  constructor(
    public readonly calculatorMessagesService: CalculatorMessagesService,
  ) {

  }

  public async ngOnInit(): Promise<void> {
    await this.calculatorMessagesService.fetch();
  }
}
